import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', href: '/' },
    { name: '动作片', href: '/category/dongzuo' },
    { name: '喜剧片', href: '/category/xiju' },
    { name: '科幻片', href: '/category/kehuan' },
  ],
  热门分类: [
    { name: '剧情片', href: '/category/juqing' },
    { name: '恐怖片', href: '/category/kongbu' },
    { name: '动画片', href: '/category/donghua' },
    { name: '纪录片', href: '/category/jilu' },
  ],
  关于我们: [
    { name: '品牌介绍', href: '/about' },
    { name: '联系方式', href: '/about#contact' },
    { name: '常见问题', href: '/#faq' },
    { name: '最新文章', href: '/article/1' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-heading font-bold text-2xl text-primary-400 whitespace-nowrap">
              91片
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              国内领先的视频内容平台，提供海量正版高清资源，极速播放、安全稳定。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://weibo.com/91pian" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base" />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-sm text-white mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 91片 版权所有 | 京ICP备2026080501号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}